import React, {
   PropsWithChildren,
   createContext,
   useContext,
   useRef
} from 'react'

import AIChatUIStore from '../../stores/AIChatUIStore/AIChatUIStore'

const AIChatUIStoreContext = createContext<AIChatUIStore | null>(null)

export const AIChatUIStoreProvider = (
   props: PropsWithChildren
): React.ReactElement => {
   const aiChatUIStore = useRef(AIChatUIStore.createStore())

   return (
      <AIChatUIStoreContext.Provider value={aiChatUIStore.current}>
         {props.children}
      </AIChatUIStoreContext.Provider>
   )
}

export const useAIChatUIStore = (): AIChatUIStore => {
   const aiChatUIStore = useContext(AIChatUIStoreContext)

   if (!aiChatUIStore) {
      throw new Error('Expected to be wrapped in AIChatUIStoreProvider')
   }

   return aiChatUIStore
}
